if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      const mengeVorher = this.warenkorbMengeAusDerSeite();

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            // Shopify antwortet mit 422, legt die verfuegbare Menge aber
            // trotzdem in den Warenkorb ("Aufgrund der Verfuegbarkeit wurden
            // nur 2 Artikel hinzugefuegt"). Bisher brach der Code hier ab —
            // Drawer und Header-Zaehler blieben auf dem alten Stand, die
            // Artikel tauchten erst nach einem Neuladen auf.
            // Die Antwort enthaelt kein maschinenlesbares Kennzeichen dafuer,
            // nur eine uebersetzte Meldung. Deshalb wird der tatsaechliche
            // Warenkorbstand nachgesehen und die Anzeige aktualisiert, wenn
            // sich etwas geaendert hat.
            this.warenkorbNachfuehren(mengeVorher);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form'});
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    /**
     * Aktuelle Warenkorbmenge aus dem Header lesen. Kostet keine Anfrage und
     * reicht als Vergleichswert. Gibt null zurueck, wenn der Zaehler fehlt —
     * dann wird im Fehlerfall nicht nachgefuehrt, statt zu raten.
     */
    warenkorbMengeAusDerSeite() {
      // Ohne den Warenkorb-Bereich im Header fehlt die Vergleichsgrundlage —
      // dann lieber nicht nachfuehren als raten.
      const bereich = document.querySelector('#cart-icon-bubble');
      if (!bereich) return null;

      const zaehler = bereich.querySelector('.welle7-header-cart-counter, .cart-count-bubble span[aria-hidden="true"]');
      // sections/cart-icon-bubble.liquid rendert den Zaehler nur bei
      // gefuelltem Warenkorb. Fehlt er, ist der Warenkorb leer — nicht etwa
      // der Wert unbekannt. Genau dieser Fall ist der haeufigste: leerer
      // Warenkorb, zu viele Stueck angefordert.
      if (!zaehler) return 0;

      const treffer = (zaehler.textContent || '').match(/\d+/);
      return treffer ? Number(treffer[0]) : 0;
    }

    /**
     * Nach einer 422-Antwort pruefen, ob doch etwas im Warenkorb gelandet ist,
     * und Drawer sowie Header-Zaehler nachziehen.
     */
    async warenkorbNachfuehren(mengeVorher) {
      if (!this.cart || mengeVorher === null) return;
      try {
        const stand = await (await fetch(`${routes.cart_url}.js`)).json();
        if (stand.item_count === mengeVorher) return;

        const abschnitte = this.cart.getSectionsToRender().map((s) => s.id).join(',');
        const antwort = await fetch(`${window.location.pathname}?sections=${abschnitte}`);
        const sections = await antwort.json();

        this.cart.renderContents({ sections });
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form' });
      } catch (e) {
        // Nachfuehren ist Komfort, kein Muss: die Fehlermeldung steht bereits.
        console.error('[Warenkorb] Nachfuehren nach Teil-Hinzufuegen fehlgeschlagen:', e);
      }
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
